function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M198.151 20.0932C198.571 20.0932 198.912 19.752 198.912 19.3311C198.912 18.9103 198.571 18.5691 198.151 18.5691C197.731 18.5691 197.391 18.9103 197.391 19.3311C197.391 19.752 197.731 20.0932 198.151 20.0932ZM198.912 22.3793C198.912 22.8002 198.571 23.1413 198.151 23.1413C197.731 23.1413 197.391 22.8002 197.391 22.3793C197.391 21.9584 197.731 21.6173 198.151 21.6173C198.571 21.6173 198.912 21.9584 198.912 22.3793ZM198.151 26.1895C198.571 26.1895 198.912 25.8483 198.912 25.4275C198.912 25.0066 198.571 24.6654 198.151 24.6654C197.731 24.6654 197.391 25.0066 197.391 25.4275C197.391 25.8483 197.731 26.1895 198.151 26.1895ZM198.912 28.4756C198.912 28.8965 198.571 29.2377 198.151 29.2377C197.731 29.2377 197.391 28.8965 197.391 28.4756C197.391 28.0547 197.731 27.7136 198.151 27.7136C198.571 27.7136 198.912 28.0547 198.912 28.4756ZM198.151 32.2858C198.571 32.2858 198.912 31.9446 198.912 31.5238C198.912 31.1029 198.571 30.7617 198.151 30.7617C197.731 30.7617 197.391 31.1029 197.391 31.5238C197.391 31.9446 197.731 32.2858 198.151 32.2858ZM198.151 35.334C198.571 35.334 198.912 34.9928 198.912 34.5719C198.912 34.1511 198.571 33.8099 198.151 33.8099C197.731 33.8099 197.391 34.1511 197.391 34.5719C197.391 34.9928 197.731 35.334 198.151 35.334ZM201.955 34.5719C201.955 34.9928 201.614 35.334 201.194 35.334C200.774 35.334 200.433 34.9928 200.433 34.5719C200.433 34.1511 200.774 33.8099 201.194 33.8099C201.614 33.8099 201.955 34.1511 201.955 34.5719ZM201.194 32.2858C201.614 32.2858 201.955 31.9446 201.955 31.5238C201.955 31.1029 201.614 30.7617 201.194 30.7617C200.774 30.7617 200.433 31.1029 200.433 31.5238C200.433 31.9446 200.774 32.2858 201.194 32.2858ZM201.955 28.4756C201.955 28.8965 201.614 29.2377 201.194 29.2377C200.774 29.2377 200.433 28.8965 200.433 28.4756C200.433 28.0547 200.774 27.7136 201.194 27.7136C201.614 27.7136 201.955 28.0547 201.955 28.4756ZM201.194 26.1895C201.614 26.1895 201.955 25.8483 201.955 25.4275C201.955 25.0066 201.614 24.6654 201.194 24.6654C200.774 24.6654 200.433 25.0066 200.433 25.4275C200.433 25.8483 200.774 26.1895 201.194 26.1895ZM201.955 22.3793C201.955 22.8002 201.614 23.1413 201.194 23.1413C200.774 23.1413 200.433 22.8002 200.433 22.3793C200.433 21.9584 200.774 21.6173 201.194 21.6173C201.614 21.6173 201.955 21.9584 201.955 22.3793ZM201.194 20.0932C201.614 20.0932 201.955 19.752 201.955 19.3311C201.955 18.9103 201.614 18.5691 201.194 18.5691C200.774 18.5691 200.433 18.9103 200.433 19.3311C200.433 19.752 200.774 20.0932 201.194 20.0932ZM204.998 34.5719C204.998 34.9928 204.657 35.334 204.237 35.334C203.817 35.334 203.476 34.9928 203.476 34.5719C203.476 34.1511 203.817 33.8099 204.237 33.8099C204.657 33.8099 204.998 34.1511 204.998 34.5719ZM204.237 32.2858C204.657 32.2858 204.998 31.9446 204.998 31.5238C204.998 31.1029 204.657 30.7617 204.237 30.7617C203.817 30.7617 203.476 31.1029 203.476 31.5238C203.476 31.9446 203.817 32.2858 204.237 32.2858ZM204.998 28.4756C204.998 28.8965 204.657 29.2377 204.237 29.2377C203.817 29.2377 203.476 28.8965 203.476 28.4756C203.476 28.0547 203.817 27.7136 204.237 27.7136C204.657 27.7136 204.998 28.0547 204.998 28.4756ZM204.237 26.1895C204.657 26.1895 204.998 25.8483 204.998 25.4275C204.998 25.0066 204.657 24.6654 204.237 24.6654C203.817 24.6654 203.476 25.0066 203.476 25.4275C203.476 25.8483 203.817 26.1895 204.237 26.1895ZM204.998 22.3793C204.998 22.8002 204.657 23.1413 204.237 23.1413C203.817 23.1413 203.476 22.8002 203.476 22.3793C203.476 21.9584 203.817 21.6173 204.237 21.6173C204.657 21.6173 204.998 21.9584 204.998 22.3793ZM204.237 20.0932C204.657 20.0932 204.998 19.752 204.998 19.3311C204.998 18.9103 204.657 18.5691 204.237 18.5691C203.817 18.5691 203.476 18.9103 203.476 19.3311C203.476 19.752 203.817 20.0932 204.237 20.0932ZM208.041 34.5719C208.041 34.9928 207.7 35.334 207.28 35.334C206.86 35.334 206.519 34.9928 206.519 34.5719C206.519 34.1511 206.86 33.8099 207.28 33.8099C207.7 33.8099 208.041 34.1511 208.041 34.5719ZM207.28 32.2858C207.7 32.2858 208.041 31.9446 208.041 31.5238C208.041 31.1029 207.7 30.7617 207.28 30.7617C206.86 30.7617 206.519 31.1029 206.519 31.5238C206.519 31.9446 206.86 32.2858 207.28 32.2858ZM208.041 28.4756C208.041 28.8965 207.7 29.2377 207.28 29.2377C206.86 29.2377 206.519 28.8965 206.519 28.4756C206.519 28.0547 206.86 27.7136 207.28 27.7136C207.7 27.7136 208.041 28.0547 208.041 28.4756ZM207.28 26.1895C207.7 26.1895 208.041 25.8483 208.041 25.4275C208.041 25.0066 207.7 24.6654 207.28 24.6654C206.86 24.6654 206.519 25.0066 206.519 25.4275C206.519 25.8483 206.86 26.1895 207.28 26.1895ZM208.041 22.3793C208.041 22.8002 207.7 23.1413 207.28 23.1413C206.86 23.1413 206.519 22.8002 206.519 22.3793C206.519 21.9584 206.86 21.6173 207.28 21.6173C207.7 21.6173 208.041 21.9584 208.041 22.3793ZM207.28 20.0932C207.7 20.0932 208.041 19.752 208.041 19.3311C208.041 18.9103 207.7 18.5691 207.28 18.5691C206.86 18.5691 206.519 18.9103 206.519 19.3311C206.519 19.752 206.86 20.0932 207.28 20.0932ZM211.083 34.5719C211.083 34.9928 210.743 35.334 210.323 35.334C209.903 35.334 209.562 34.9928 209.562 34.5719C209.562 34.1511 209.903 33.8099 210.323 33.8099C210.743 33.8099 211.083 34.1511 211.083 34.5719ZM210.323 32.2858C210.743 32.2858 211.083 31.9446 211.083 31.5238C211.083 31.1029 210.743 30.7617 210.323 30.7617C209.903 30.7617 209.562 31.1029 209.562 31.5238C209.562 31.9446 209.903 32.2858 210.323 32.2858ZM211.083 28.4756C211.083 28.8965 210.743 29.2377 210.323 29.2377C209.903 29.2377 209.562 28.8965 209.562 28.4756C209.562 28.0547 209.903 27.7136 210.323 27.7136C210.743 27.7136 211.083 28.0547 211.083 28.4756ZM210.323 26.1895C210.743 26.1895 211.083 25.8483 211.083 25.4275C211.083 25.0066 210.743 24.6654 210.323 24.6654C209.903 24.6654 209.562 25.0066 209.562 25.4275C209.562 25.8483 209.903 26.1895 210.323 26.1895ZM211.083 22.3793C211.083 22.8002 210.743 23.1413 210.323 23.1413C209.903 23.1413 209.562 22.8002 209.562 22.3793C209.562 21.9584 209.903 21.6173 210.323 21.6173C210.743 21.6173 211.083 21.9584 211.083 22.3793ZM210.323 20.0932C210.743 20.0932 211.083 19.752 211.083 19.3311C211.083 18.9103 210.743 18.5691 210.323 18.5691C209.903 18.5691 209.562 18.9103 209.562 19.3311C209.562 19.752 209.903 20.0932 210.323 20.0932ZM214.126 34.5719C214.126 34.9928 213.786 35.334 213.366 35.334C212.945 35.334 212.605 34.9928 212.605 34.5719C212.605 34.1511 212.945 33.8099 213.366 33.8099C213.786 33.8099 214.126 34.1511 214.126 34.5719ZM213.366 32.2858C213.786 32.2858 214.126 31.9446 214.126 31.5238C214.126 31.1029 213.786 30.7617 213.366 30.7617C212.945 30.7617 212.605 31.1029 212.605 31.5238C212.605 31.9446 212.945 32.2858 213.366 32.2858ZM214.126 28.4756C214.126 28.8965 213.786 29.2377 213.366 29.2377C212.945 29.2377 212.605 28.8965 212.605 28.4756C212.605 28.0547 212.945 27.7136 213.366 27.7136C213.786 27.7136 214.126 28.0547 214.126 28.4756ZM213.366 26.1895C213.786 26.1895 214.126 25.8483 214.126 25.4275C214.126 25.0066 213.786 24.6654 213.366 24.6654C212.945 24.6654 212.605 25.0066 212.605 25.4275C212.605 25.8483 212.945 26.1895 213.366 26.1895ZM214.126 22.3793C214.126 22.8002 213.786 23.1413 213.366 23.1413C212.945 23.1413 212.605 22.8002 212.605 22.3793C212.605 21.9584 212.945 21.6173 213.366 21.6173C213.786 21.6173 214.126 21.9584 214.126 22.3793ZM213.366 20.0932C213.786 20.0932 214.126 19.752 214.126 19.3311C214.126 18.9103 213.786 18.5691 213.366 18.5691C212.945 18.5691 212.605 18.9103 212.605 19.3311C212.605 19.752 212.945 20.0932 213.366 20.0932Z",
  fill: "url(#paint0_linear_805_42743)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M196.87 60.2273C206.209 60.2273 213.779 52.6431 213.779 43.2875C213.779 33.9319 206.209 26.3477 196.87 26.3477C187.531 26.3477 179.961 33.9319 179.961 43.2875C179.961 52.6431 187.531 60.2273 196.87 60.2273Z",
  fill: "url(#paint1_linear_805_42743)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M118.192 3.01221C127.721 3.01221 135.446 10.7512 135.446 20.2977V28.4219H95.0707C85.5414 28.4219 77.8164 20.6829 77.8164 11.1364V3.01221H118.192Z",
  fill: "url(#paint2_linear_805_42743)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M134.238 134.728C134.238 114.298 150.714 97.7368 171.038 97.7368C191.362 97.7368 207.837 114.298 207.837 134.728H134.238Z",
  fill: "url(#paint3_linear_805_42743)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3361 112.287C24.6252 116.681 16.8615 116.625 11.0451 112.12C5.22861 107.615 1.54693 101.2 0 92.8748C18.1812 87.4051 29.6266 93.8758 34.3361 112.287Z",
  fill: "url(#paint4_linear_805_42743)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9986 104.387C17.9027 103.196 15.5722 101.876 13.007 100.427L7.05677 101.854C6.95121 101.88 6.84522 101.814 6.82003 101.708C6.79485 101.602 6.86 101.495 6.96556 101.47L12.5022 100.142C9.3007 98.3342 5.74237 96.3307 1.82725 94.1313C1.73251 94.0781 1.69862 93.9577 1.75156 93.8625C1.80449 93.7672 1.9242 93.7331 2.01894 93.7864C9.16751 97.8022 15.1266 101.165 19.8964 103.875L19.281 97.8106C19.2544 97.5485 19.6453 97.5084 19.6719 97.7705L20.3156 104.113C26.675 107.728 30.857 110.147 32.8623 111.372C32.9551 111.428 32.9846 111.55 32.9283 111.643C32.872 111.736 32.7511 111.766 32.6583 111.709C31.4584 110.977 29.4761 109.814 26.7114 108.223C26.7041 108.226 26.6965 108.23 26.6886 108.233L21.2509 110.229C21.1489 110.267 21.0361 110.214 20.9989 110.111C20.9617 110.009 21.0141 109.896 21.116 109.858L26.2668 107.967C24.4997 106.951 22.4312 105.769 20.0615 104.422C20.0386 104.415 20.0172 104.403 19.9986 104.387Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.16 117.788C22.1778 114 16.7123 108.455 15.7635 101.156C14.8146 93.8566 16.7256 86.7246 21.4964 79.76C38.2427 88.7962 41.7972 101.472 32.16 117.788Z",
  fill: "url(#paint5_linear_805_42743)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0492 102.111C29.999 109.187 31.2516 113.87 31.807 116.161C31.8327 116.267 31.7683 116.374 31.6631 116.4C31.558 116.425 31.4519 116.361 31.4262 116.255C31.0938 114.884 30.5109 112.653 29.6774 109.563C29.6697 109.56 29.662 109.557 29.6544 109.553L24.4175 107.1C24.3194 107.054 24.2768 106.936 24.3224 106.837C24.3681 106.738 24.4847 106.696 24.5829 106.742L29.5433 109.066C29.0096 107.091 28.3795 104.786 27.6528 102.149C27.6421 102.127 27.6353 102.104 27.6335 102.079C26.9908 99.7473 26.2729 97.1576 25.4799 94.31L20.2809 91.0898C20.1887 91.0326 20.1599 90.911 20.2166 90.8181C20.2733 90.7251 20.394 90.6961 20.4862 90.7532L25.3238 93.7496C24.3337 90.1961 23.2292 86.2505 22.0106 81.9127C21.9811 81.8078 22.0416 81.6986 22.1458 81.6689C22.25 81.6392 22.3583 81.7002 22.3878 81.8051C24.613 89.7254 26.4572 96.3384 27.9206 101.645L31.7414 96.9199C31.9065 96.7157 32.2104 96.9653 32.0453 97.1694L28.0492 102.111Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1008 124.627C33.8573 131.402 26.3495 133.371 19.5772 130.533C12.8049 127.694 7.60212 122.454 3.96875 114.812C20.1112 104.79 32.8219 108.062 42.1008 124.627Z",
  fill: "url(#paint6_linear_805_42743)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M26.429 120.228C33.4973 122.06 38.1563 123.305 40.407 123.964C40.5111 123.995 40.5708 124.104 40.5404 124.208C40.5101 124.313 40.401 124.373 40.2969 124.342C38.9502 123.948 36.7378 123.343 33.6597 122.527C33.6536 122.533 33.6472 122.538 33.6403 122.543L28.9051 125.877C28.8164 125.939 28.6939 125.918 28.6316 125.829C28.5693 125.739 28.5908 125.617 28.6795 125.554L33.1648 122.396C31.1977 121.876 28.8972 121.275 26.2633 120.592C26.2393 120.591 26.2155 120.585 26.1935 120.574C23.864 119.971 21.2749 119.304 18.4262 118.574L13.0499 121.493C12.9545 121.545 12.8354 121.509 12.7838 121.414C12.7322 121.318 12.7676 121.198 12.863 121.147L17.8655 118.431C14.3103 117.52 10.3603 116.514 6.01544 115.412C5.91031 115.385 5.84664 115.278 5.87323 115.172C5.89982 115.067 6.00661 115.003 6.11174 115.03C14.0449 117.043 20.6619 118.735 25.9631 120.108L23.809 114.427C23.7159 114.181 24.083 114.041 24.1761 114.287L26.429 120.228Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9548 35.6819H131.304C133.21 35.6819 134.755 37.2297 134.755 39.139V131.341C134.755 133.251 133.21 134.798 131.304 134.798H32.9548C31.0489 134.798 29.5039 133.251 29.5039 131.341V39.139C29.5039 37.2297 31.0489 35.6819 32.9548 35.6819Z",
  fill: "url(#paint7_linear_805_42743)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.4062 58.3259H53.6606V75.6115H36.4062V58.3259ZM36.4062 84.2542H53.6606V101.54H36.4062V84.2542ZM53.6606 110.183H36.4062V127.468H53.6606V110.183ZM85.581 58.3259H102.835V75.6115H85.581V58.3259ZM102.835 84.2542H85.581V101.54H102.835V84.2542ZM85.581 110.183H102.835V127.468H85.581V110.183ZM78.3342 58.3259H61.0799V75.6115H78.3342V58.3259ZM61.0799 110.183H78.3342V127.468H61.0799V110.183ZM127.509 58.3259H110.255V75.6115H127.509V58.3259ZM110.255 84.2542H127.509V101.54H110.255V84.2542ZM127.509 110.183H110.255V127.468H127.509V110.183Z",
  fill: "#77D0E6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M61.0781 84.2542H78.3324V101.54H61.0781V84.2542Z",
  fill: "url(#paint8_linear_805_42743)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9548 35.6819H131.304C133.21 35.6819 134.755 37.2297 134.755 39.139V51.5846H29.5039V39.139C29.5039 37.2297 31.0489 35.6819 32.9548 35.6819Z",
  fill: "url(#paint9_linear_805_42743)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M74.4945 88.6619L75.7262 89.8724L67.9932 97.769L63.7539 93.5934L64.9636 92.3608L67.9711 95.3232L74.4945 88.6619Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5811 63.5116C58.1621 63.5116 71.6036 50.0457 71.6036 33.4347C71.6036 16.8238 58.1621 3.35791 41.5811 3.35791C25.0001 3.35791 11.5586 16.8238 11.5586 33.4347C11.5586 50.0457 25.0001 63.5116 41.5811 63.5116Z",
  fill: "url(#paint10_linear_805_42743)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6688 57.9803C55.1527 57.9803 66.0836 47.0296 66.0836 33.5213C66.0836 20.0129 55.1527 9.06226 41.6688 9.06226C28.1848 9.06226 17.2539 20.0129 17.2539 33.5213C17.2539 47.0296 28.1848 57.9803 41.6688 57.9803Z",
  fill: "url(#paint11_linear_805_42743)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M20.207 34.0664C20.207 20.7731 30.9639 9.99683 44.2331 9.99683C46.7385 9.99683 49.1543 10.381 51.4251 11.0937C60.0522 14.8662 66.0821 23.4882 66.0821 33.5211C66.0821 47.0295 55.1512 57.9801 41.6672 57.9801C41.6042 57.9801 41.5411 57.9799 41.4782 57.9794C29.5064 56.6103 20.207 46.4263 20.207 34.0664Z",
  fill: "url(#paint12_linear_805_42743)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M52.5771 23.2587C53.2318 22.565 54.3239 22.5345 55.0162 23.1904C55.7086 23.8464 55.7391 24.9404 55.0844 25.634L40.4739 41.1118C39.9415 41.6758 39.0989 41.8151 38.4138 41.4522L28.6966 36.3053C27.8542 35.8591 27.5324 34.8132 27.9778 33.9692C28.4232 33.1253 29.4672 32.8028 30.3096 33.2491L38.8676 37.782L52.5771 23.2587Z",
  fill: "url(#paint13_linear_805_42743)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M116.922 67.781L208.92 43.0855C211.129 42.4925 213.4 43.8059 213.992 46.019L229.711 104.791C230.303 107.004 228.992 109.279 226.783 109.872L134.785 134.567C132.576 135.16 130.305 133.847 129.713 131.634L113.994 72.8619C113.402 70.6488 114.713 68.374 116.922 67.781Z",
  fill: "url(#paint14_linear_805_42743)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M171.138 86.1548L226.784 109.872L134.785 134.567L171.138 86.1548Z",
  fill: "url(#paint15_linear_805_42743)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M116.922 67.781L208.92 43.0854L173.736 95.8681L116.922 67.781Z",
  fill: "#52D7FD"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M154.014 57.8234L151.129 47.0361L151.726 42.8928L163.829 47.2689L169.525 53.6598L154.014 57.8234Z",
  fill: "#121958"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M143.67 29.3103L148.219 31.8474L147.741 35.8446L152.248 39.5439L151.088 42.573L145.199 38.8996C143.376 37.7628 142.443 35.6166 142.854 33.5054L143.67 29.3103Z",
  fill: "#E9A17C"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M149.408 15.7285L151.817 24.7357L147.477 33.0511L142.742 29.5075L145.606 18.8209L149.408 15.7285Z",
  fill: "#D64F53"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M178.613 69.5421L178.675 66.7166L182.531 67.086L181.948 70.2241L178.613 69.5421Z",
  fill: "#E9A17C"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M162.797 12.9048L190.442 5.48398L191.327 3.427L191.781 5.12432L195.163 4.21648C195.318 6.10363 194.972 7.39439 194.124 8.08874C193.277 8.78309 191.884 9.15687 189.947 9.21007L164.62 19.7227L162.797 12.9048Z",
  fill: "#E9A17C"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M154.707 15.5115L149.566 15.9621L149.394 13.9912C148.056 12.2863 147.496 9.80499 147.713 6.54726C147.931 3.28953 150.392 2.20885 155.097 3.30521C155.383 5.14908 155.971 6.2779 156.859 6.69166C158.192 7.3123 157.895 8.02682 157.469 8.27883C157.043 8.53085 156.786 8.91832 157.013 9.98218C157.24 11.046 156.604 11.3164 155.621 11.8307C154.965 12.1736 154.661 13.4005 154.707 15.5115Z",
  fill: "#E9A17C"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M152.824 44.0893L167.612 42.5408L183.519 43.7926C183.84 43.8179 184.159 43.8743 184.469 43.961C187.132 44.7036 188.689 47.4676 187.947 50.1347L183.01 67.9003L178.051 67.5048L179.289 51.1648L165.081 54.9787C159.033 56.6022 152.816 53.0065 151.195 46.9476L152.824 44.0893Z",
  fill: "url(#paint16_linear_805_42743)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M178.204 69.2258L182.108 69.5681L184.51 70.612C185.717 71.1635 186.751 71.436 186.63 72.8213C186.599 73.1772 186.339 73.4451 186.048 73.4196L178.725 72.7777C178.269 72.7378 177.932 72.3354 177.972 71.8789L178.204 69.2258Z",
  fill: "#211D41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M149.319 13.9559C148.839 13.8913 148.522 13.6735 148.367 13.3025C148.134 12.7461 148.408 12.3995 146.997 11.4709C145.585 10.5422 144.31 9.17839 144.403 6.27051C144.497 3.36264 146.087 2.76023 147.693 2.24234C149.298 1.72445 150.006 1.76224 152.087 0.505528C154.168 -0.751184 155.637 0.454278 155.66 2.80707C155.683 5.15985 152.281 5.85583 151.668 5.90958C151.054 5.96333 151.553 6.79006 151.824 7.69575C152.094 8.60144 151.552 8.93512 151.308 8.85435C151.064 8.77357 150.573 8.72643 150.274 9.32817C149.975 9.9299 150.564 10.6437 150.901 10.6142C151.238 10.5847 151.651 10.3903 151.751 10.7594C151.851 11.1284 151.915 12.32 151.671 13.0129C151.508 13.4748 150.724 13.7892 149.319 13.9559Z",
  fill: "url(#paint17_linear_805_42743)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M165.167 11.0923L167.35 19.257L161.551 20.8136L167.4 42.6805L151.132 47.0474L144.975 24.0283C143.939 20.1554 146.234 16.1745 150.1 15.1368C150.831 14.9404 151.563 14.744 152.294 14.5476C153.802 14.1429 158.093 12.9911 165.167 11.0923Z",
  fill: "url(#paint18_linear_805_42743)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.223 46.2064L159.341 46.0803L160.221 46.9083L160.103 47.0344L159.223 46.2064ZM161.362 48.2172L161.48 48.0912L161.814 48.4057C161.994 48.575 162.184 48.7329 162.382 48.8787L162.28 49.0181C162.076 48.8681 161.881 48.7058 161.696 48.5318L161.362 48.2172ZM163.879 49.6856L163.819 49.8477C164.202 49.99 164.599 50.0946 165.003 50.1599L165.03 49.9892C164.638 49.9257 164.252 49.824 163.879 49.6856ZM166.751 50.196L166.731 50.0243L166.77 50.0196L167.929 49.8735L167.95 50.045L166.791 50.1911L166.751 50.196ZM169.641 49.6579L169.662 49.8294L170.861 49.6784L170.839 49.5069L169.641 49.6579ZM172.573 49.4628L172.551 49.2913L173.75 49.1403L173.771 49.3118L172.573 49.4628ZM175.461 48.9246L175.483 49.0961L176.681 48.9452L176.66 48.7737L175.461 48.9246ZM178.393 48.7295L178.372 48.558L179.57 48.4071L179.592 48.5786L178.393 48.7295ZM181.316 48.358L181.275 48.5257C181.66 48.6219 182.011 48.814 182.298 49.0826L182.416 48.9563C182.107 48.6678 181.731 48.4613 181.316 48.358ZM183.026 50.5431L183.198 50.525C183.219 50.7296 183.216 50.9372 183.186 51.1447L183.096 51.7585L182.926 51.7334L183.015 51.1199C183.043 50.9268 183.046 50.7335 183.026 50.5431ZM182.846 53.4687L182.675 53.4437L182.5 54.6409L182.671 54.6659L182.846 53.4687ZM182.25 56.3512L182.421 56.3762L182.246 57.5734L182.075 57.5484L182.25 56.3512ZM181.995 59.2837L181.825 59.2586L181.65 60.4558L181.82 60.4809L181.995 59.2837ZM181.399 62.1661L181.57 62.1912L181.395 63.3884L181.224 63.3633L181.399 62.1661ZM181.145 65.0987L180.974 65.0736L180.799 66.2708L180.97 66.2959L181.145 65.0987Z",
  fill: "white"
});

var _ref35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_805_42743",
  x1: 197.391,
  y1: 18.5691,
  x2: 197.391,
  y2: 35.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_805_42743",
  x1: 172.556,
  y1: 28.8088,
  x2: 172.556,
  y2: 77.5255,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0F6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8BE2F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_805_42743",
  x1: 72.0251,
  y1: 12.4729,
  x2: 83.0031,
  y2: 31.5187,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFE49F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A9D386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_805_42743",
  x1: 118.141,
  y1: 97.7368,
  x2: 118.141,
  y2: 150.909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC8C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_805_42743",
  x1: -3.4505,
  y1: 100.134,
  x2: 8.77667,
  y2: 113.218,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFE49F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A9D386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_805_42743",
  x1: 17.1914,
  y1: 87.0769,
  x2: 30.6593,
  y2: 100.478,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#77D791"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4FA67E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_805_42743",
  x1: -4.86295,
  y1: 125.49,
  x2: 19.8433,
  y2: 149.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EAE7C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0F575D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_805_42743",
  x1: 6.45733,
  y1: 42.8821,
  x2: 6.45733,
  y2: 185.405,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0F6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8BE2F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_805_42743",
  x1: 61.0781,
  y1: 84.2542,
  x2: 61.0781,
  y2: 101.54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_805_42743",
  x1: 35.0991,
  y1: 39.6576,
  x2: 36.6654,
  y2: 58.1857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F1752"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272884"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_805_42743",
  x1: 11.5586,
  y1: 3.35791,
  x2: 11.5586,
  y2: 63.5116,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_805_42743",
  x1: 6.5618,
  y1: 12.6159,
  x2: 6.5618,
  y2: 82.9568,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0F6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8BE2F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_805_42743",
  x1: 22.0768,
  y1: 9.99683,
  x2: 22.0768,
  y2: 54.0687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_805_42743",
  x1: 27.7773,
  y1: 22.7178,
  x2: 27.7773,
  y2: 41.6527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_805_42743",
  x1: 113.852,
  y1: 42.9431,
  x2: 113.852,
  y2: 134.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DBCFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1486DB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_805_42743",
  x1: 148.76,
  y1: 86.1548,
  x2: 148.76,
  y2: 119.859,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DBCFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1486DB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_805_42743",
  x1: 137.443,
  y1: 29.1126,
  x2: 137.443,
  y2: 89.878,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1533B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#356BE9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_805_42743",
  x1: 144.398,
  y1: 0,
  x2: 144.398,
  y2: 13.9559,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D2A78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12033B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_805_42743",
  x1: 144.727,
  y1: 11.0923,
  x2: 144.727,
  y2: 47.0474,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})));

function SvgBusinessSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 135,
    viewBox: "0 0 230 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSchedule);
export default __webpack_public_path__ + "static/media/business_schedule.ca323f8b.svg";
export { ForwardRef as ReactComponent };